
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m61.9 44.2l-4.4-22.1c-1-5.1-5.4-9-10.7-9.1h-29.5c-5.4 0-9.9 3.9-10.8 9.1l-4.4 22.1c-.1.4-.1.8-.1 1.2 0 3.1 2.5 5.6 5.5 5.6 2 0 3.7-1 4.7-2.6l7.2-9c1.2 1.1 2.7 1.8 4.4 1.8 3.6 0 6.5-2.9 6.5-6.6h3.5c0 3.6 2.9 6.6 6.5 6.6 1.7 0 3.2-.6 4.4-1.7l7.2 9c1 1.6 2.7 2.6 4.7 2.6 3 0 5.5-2.5 5.5-5.6-.1-.5-.1-.9-.2-1.3", fill: "#333" }),
	React.createElement(
		"g",
		{ fill: "#94989b" },
		React.createElement("path", { d: "m20.9 25.2c.7.7 1.5.5 1.8-.5v-3.1c-.3-1-1.1-1.2-1.8-.5l-.7.7c-.7.7-.7 1.9 0 2.6l.7.8" }),
		React.createElement("path", { d: "m15.8 17.8c-1 .3-1.2 1.1-.5 1.8l.7.7c.7.7 1.9.7 2.6 0l.7-.7c.7-.7.5-1.5-.5-1.8h-3" }),
		React.createElement("path", { d: "m13.8 21.2c-.7-.7-1.5-.5-1.8.5v3.1c.3 1 1.1 1.2 1.8.5l.7-.7c.7-.7.7-1.9 0-2.6l-.7-.8" }),
		React.createElement("path", { d: "m18.9 28.7c1-.3 1.2-1.1.5-1.8l-.7-.7c-.7-.7-1.9-.7-2.6 0l-.7.7c-.7.7-.5 1.5.5 1.8h3" })
	),
	React.createElement(
		"g",
		{ fill: "#f2b200" },
		React.createElement("path", { d: "m49.5 23.2c-1 0-1.8.8-1.8 1.8 0 1 .8 1.8 1.8 1.8 1 0 1.8-.8 1.8-1.8 0-1-.8-1.8-1.8-1.8" }),
		React.createElement("path", { d: "m44.2 25.1c-1 0-1.8.8-1.8 1.8 0 1 .8 1.8 1.8 1.8 1 0 1.8-.8 1.8-1.8.1-1-.8-1.8-1.8-1.8" }),
		React.createElement("path", { d: "m49.3 21.4c1 0 1.8-.8 1.8-1.8 0-1-.8-1.8-1.8-1.8-1 0-1.8.8-1.8 1.8 0 .9.8 1.8 1.8 1.8" }),
		React.createElement("path", { d: "m44.1 23.2c1 0 1.8-.8 1.8-1.8 0-1-.8-1.8-1.8-1.8-1 0-1.8.8-1.8 1.8 0 1 .8 1.8 1.8 1.8" })
	),
	React.createElement(
		"g",
		{ fill: "#94989b" },
		React.createElement("ellipse", { cx: "40.3", cy: "34.5", rx: "4.3", ry: "4.4" }),
		React.createElement("path", { d: "m23.8 30.1c-2.4 0-4.3 2-4.3 4.4 0 2.4 1.9 4.4 4.3 4.4 2.4 0 4.3-2 4.3-4.4.1-2.4-1.9-4.4-4.3-4.4" })
	)
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/video_game.js
// module id = 736
// module chunks = 0